import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.invitationsByOrg>>;

export const createFetchOrganizationInvitationsQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ organizationId }], signal }: TParams) =>
    (await call(() => cancelOnSignal(AdminService.getInvitations({ oid: organizationId }), signal))) ?? [];
